<template>
  <section class="global-box">
    <div class="content-box">
      <h2>Nosso produto</h2>
      <a href="https://represente.com.br" target="_blank" class="link">
        <img
          class="logo-represente"
          src="https://thiagoalmeida.com.br/img/clients/brandRepresente.svg"
        />
      </a>
      <h3>sistema de gestão de clientes</h3>
      <p>
        A ferramenta que vai dar mais agilidade ao seu time de vendas,
        além de estreitar ainda mais a relação de seu negócio com quem
        importa: seus clientes.
      </p>
      <section class="content-product">
        <div v-for="(item, index) in represente" :key="index" class="unitary">
          <icon :description="item.icon" :size="item.size" />
          <h3>{{item.title}}</h3>
          <p>{{item.description}}</p>
        </div>
      </section>
      <a href="https://represente.com.br" target="_blank" class="button">
        Aproveite agora mesmo
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'products-section',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      flutuation: false,
      represente: [
        {
          title: 'Clientes',
          description: `Centralize em um só lugar as informações básicas
          e o histórico de relacionamento com seus clientes`,
          icon: 'icon-clients',
          size: '64',
        },
        {
          title: 'Agendamentos',
          description: `Listamos os clientes foram agendados para
          realizar contato no dia e quais, por ventura, estão com contatos
          atrasados`,
          icon: 'icon-scadule-old',
          size: '60',
        },
        {
          title: 'Níveis de acesso',
          description: `Cada usuário poderá acessar funções e ações que
          realmente são adequadas para o seu perfil, otimizando assim o
          trabalho`,
          icon: 'icon-access-level',
          size: '68',
        },
        {
          title: 'Online',
          description: `Tenha acesso às informações de qualquer lugar e
          em qualquer dispositivo, necessitando apenas do acesso a
          internet`,
          icon: 'icon-online',
          size: '68',
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  section
    width: 100%
  .global-box
    padding: 0 !important
    overflow: initial !important
    .content-box
      .link
        margin: 0 auto 12px
        .logo-represente
          width: 160px
      .content-product
        display: flex
        flex-wrap: wrap
        justify-content: space-evenly
        padding-top: 32px
        .unitary
          width: 40%
          padding: 12px 32px 40px
          display: flex
          flex-wrap: wrap
          justify-content: center
          p
            text-align: center
          svg
            fill: $grey-900
            margin-bottom: 16px
  @media (max-width: $widthTerciarySmall)
    p
      text-align: justify
    .content-box
      .content-product
        .unitary
          width: 100% !important
</style>
